<div
  class="frosty flex h-full w-full min-w-0 flex-col overflow-hidden"
  [class.cursor-pointer]="clickable">
  <header
    class="flex justify-between gap-3"
    [ngClass]="compact && variant === 'built-in'
      ? 'min-h-[2.7rem] items-center px-[0.8rem] py-[0.65rem]'
      : compact
        ? 'min-h-[3.1rem] items-start px-[0.95rem] py-[0.65rem]'
        : variant === 'built-in'
          ? 'min-h-[2.7rem] items-center px-[0.8rem] py-[0.62rem]'
          : 'min-h-[3.1rem] items-start px-[0.95rem] py-[0.78rem]'">
    <div class="min-w-0">
      <p *ngIf="eyebrow" class="max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-[0.625rem] font-bold uppercase leading-none tracking-[0.14em] text-slate-500">
        {{ eyebrow }}
      </p>
      <h3
        class="flex min-w-0 items-center gap-[0.35rem] font-bold text-slate-900"
        [ngClass]="variant === 'built-in' ? 'mt-0 text-[0.8rem] leading-[1.15]' : 'mt-[0.15rem] text-[0.86rem] leading-[1.2]'"
        [title]="subtitle || title">
        <fa-icon *ngIf="icon" [icon]="icon" class="shrink-0 text-slate-500"></fa-icon>
        <span>{{ title }}</span>
      </h3>
      <p *ngIf="subtitle" class="mt-[0.2rem] overflow-hidden text-ellipsis whitespace-nowrap text-[0.72rem] leading-[1.2] text-slate-500">
        {{ subtitle }}
      </p>
      <ng-content select="[widget-meta]"></ng-content>
    </div>

    <div class="flex shrink-0 items-center gap-1">
      <span *ngIf="errorCount > 0" class="inline-flex h-[1.35rem] min-w-[1.35rem] items-center justify-center rounded-full bg-rose-100/90 text-[0.68rem] font-extrabold text-rose-700">
        {{ errorCount }}
      </span>
      <ng-content select="[widget-actions]"></ng-content>
    </div>
  </header>

  <app-dashboard-widget-body [compact]="compact" [variant]="variant">
    <ng-content></ng-content>
  </app-dashboard-widget-body>
</div>
